<template>
  <g>
    <path
      d="M14 9.00024H10C9.45 9.00024 9 8.55024 9 8.00024C9 7.45024 9.45 7.00024 10 7.00024H14C14.55 7.00024 15 7.45024 15 8.00024C15 8.55024 14.55 9.00024 14 9.00024Z"
    />
    <path
      d="M14 12.0002H10C9.45 12.0002 9 11.5502 9 11.0002C9 10.4502 9.45 10.0002 10 10.0002H14C14.55 10.0002 15 10.4502 15 11.0002C15 11.5502 14.55 12.0002 14 12.0002Z"
    />
    <path
      d="M19.5 3.50024L18 2.00024L16.5 3.50024L15 2.00024L13.5 3.50024L12 2.00024L10.5 3.50024L9 2.00024L7.5 3.50024L6 2.00024V16.0002H4C3.45 16.0002 3 16.4502 3 17.0002V19.0002C3 20.6602 4.34 22.0002 6 22.0002H18C19.66 22.0002 21 20.6602 21 19.0002V2.00024L19.5 3.50024ZM15 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002V18.0002H8H12H15V20.0002ZM19 19.0002C19 19.5502 18.55 20.0002 18 20.0002C17.45 20.0002 17 19.5502 17 19.0002V17.0002C17 16.4502 16.55 16.0002 16 16.0002H14H12H8V5.00024H19V19.0002Z"
    />
    <path
      d="M17 9.00024C17.5523 9.00024 18 8.55253 18 8.00024C18 7.44796 17.5523 7.00024 17 7.00024C16.4477 7.00024 16 7.44796 16 8.00024C16 8.55253 16.4477 9.00024 17 9.00024Z"
    />
    <path
      d="M17 12.0002C17.5523 12.0002 18 11.5525 18 11.0002C18 10.448 17.5523 10.0002 17 10.0002C16.4477 10.0002 16 10.448 16 11.0002C16 11.5525 16.4477 12.0002 17 12.0002Z"
    />
  </g>
</template>
